import React, { useState } from 'react'
import VipEventForm from '../components/VipEventForm'
import axios from 'axios';
import VipEventFormSuccess from '../components/VipEventFormSuccess';

const VipEventView = ({ config, days }) => {
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [data, setData] = useState(null);
    const onSubmit = async (data) => {
        setSubmitting(true);
        setErrorMsg(null);
        const response = await axios.post(config.submitUrl, data);
        setSubmitting(false);
        if (response.status === 200) {
            setData(data);
            setSubmitted(true);
        } else {
            setErrorMsg('Something went wrong. Please try again or give us a call')
        }
    }
    return (
        submitted ? <VipEventFormSuccess data={data}></VipEventFormSuccess> : <VipEventForm errorMsg={errorMsg} disabled={submitting} onSubmit={onSubmit} days={days}></VipEventForm>
    )
}

export default VipEventView